import { axiosTemplate } from '@page/explorer/templates/axios.template';
import { curlTemplate } from '@page/explorer/templates/curl.template';
import { goTemplate } from '@page/explorer/templates/go.template';
import { jsTemplate } from '@page/explorer/templates/js.template';
import { phpTemplate } from '@page/explorer/templates/php.template';
import { pythonTemplate } from '@page/explorer/templates/python.template';
import { rubyTemplate } from '@page/explorer/templates/ruby.template';

import { MethodEnum } from '@enum/method.enum';

export enum LanguageTemplateEnum {
  AXIOS,
  JS,
  PHP,
  PYTHON,
  RUBY,
  CURL,
  GO,
}

export const getTemplate =
  (language: LanguageTemplateEnum) =>
  (
    link: string,
    headers: Record<string, string>,
    body: Record<string, string>,
    method: MethodEnum = MethodEnum.GET,
  ) => {
    switch (language) {
      case LanguageTemplateEnum.AXIOS:
        return axiosTemplate(link, headers, body, method);
      case LanguageTemplateEnum.JS:
        return jsTemplate(link, headers, body, method);
      case LanguageTemplateEnum.PHP:
        return phpTemplate(link, headers, body, method);
      case LanguageTemplateEnum.PYTHON:
        return pythonTemplate(link, headers, body, method);
      case LanguageTemplateEnum.RUBY:
        return rubyTemplate(link, headers, body, method);
      case LanguageTemplateEnum.CURL:
        return curlTemplate(link, headers, body, method);
      case LanguageTemplateEnum.GO:
        return goTemplate(link, headers, body, method);
      default:
        return '';
    }
  };

export const getCodeLanguage = (language: LanguageTemplateEnum) => {
  switch (language) {
    case LanguageTemplateEnum.PYTHON:
      return 'python';
    case LanguageTemplateEnum.RUBY:
      return 'ruby';
    case LanguageTemplateEnum.CURL:
      return 'bash';
    case LanguageTemplateEnum.GO:
      return 'go';
    case LanguageTemplateEnum.PHP:
    case LanguageTemplateEnum.AXIOS:
    case LanguageTemplateEnum.JS:
    default:
      return 'javascript';
  }
};
